import type { BeforeRequestHook } from "ky";

import { logOut } from "@/redux/actions/logout";
import store from "@/redux/store";

import { workflowTokenStore } from "../../helpers/workflowTokenStore";

// store.dispatch is typed as Dispatch<AnyAction> but auth actions are thunks
const dispatch: (action: any) => any = store.dispatch;

export const workflowAuthHook: BeforeRequestHook = ({ request }) => {
  const tokens = workflowTokenStore.get();

  if (!tokens?.idToken) {
    dispatch(logOut());

    return new Response(
      JSON.stringify({ error: { message: "Missing workflow authentication token" } }),
      { headers: { "Content-Type": "application/json" }, status: 401 },
    );
  }

  request.headers.set("Authorization", tokens.idToken);
  request.headers.set("Accept", "application/json");
  request.headers.set("x-location-path-name", window.location.pathname);

  return undefined;
};
